export default "__VITE_ASSET__CI9rJ4dk__"